import { EllipsesIcon } from 'foundations-assets/icons/components/EllipsesIcon';
import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';

// this is a copy-paste from ActionsMenu because they are not exported properly
import { jsx as _jsx } from "react/jsx-runtime";
export function ListingActionMenu({
  actions,
  onActionClick
}) {
  return /*#__PURE__*/_jsx(ActionsMenu, {
    actions: actions,
    onActionClick: onActionClick,
    referenceIndicator: /*#__PURE__*/_jsx(IconHolder, {
      rotate: 90,
      rotateLock: true,
      icon: EllipsesIcon
    }),
    referenceSize: "compact",
    use: "tertiary-extra-light"
  });
}